import React, { useState, useCallback } from "react";
import { PERIODS, getPeriodRange } from "../constants";
import { SubtotalCell } from "./SubtotalCell";

const PIPELINE_HELP =
  "Pipeline = valor total de oportunidades\nal 90% y 75% (sin ponderar).\n\n" +
  "Vigencia automática:\n" +
  "- 90% \u2192 75% tras 10 días hábiles\n" +
  "- 75% \u2192 50% tras 25 días hábiles\n" +
  "- 50% \u2192 0% tras 40 días hábiles\n\n" +
  "El reloj se reinicia al editar la oportunidad.";

// Fondos para filas de período: Q claro, H medio, TOTAL oscuro
const PERIOD_BG = {
  quarter: {},
  half: { backgroundColor: "#555" },
  year: { backgroundColor: "#555" },
};

export const VentasTable = ({
  vistaCompleta,
  mostrar2025,
  getDesglose,
  getMoneda,
  getDisplayValue,
  getMonthName,
  calcularVariacion,
  shouldShowVsAA,
  calcularPipelineBruto,
  calcularPipelineBrutoTotal,
  onOpenModal,
  onOpenPipelineModal,
  currentMonthIndex,
  styles,
}) => {
  const subtotalProps = { getDesglose, getMoneda, getDisplayValue, onOpenModal, currentMonthIndex };
  const [tip, setTip] = useState(null);

  const showTip = useCallback((e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setTip({ top: r.bottom + 6, left: r.left - 240 });
  }, []);
  const hideTip = useCallback(() => setTip(null), []);

  if (vistaCompleta === "cierres") {
    return (
      <>
        {tip && (
          <div className="pipeline-tooltip-floating" style={{ top: tip.top, left: tip.left }}>
            {PIPELINE_HELP}
          </div>
        )}
        <table className={styles.tableVentas}>
          <colgroup>
            <col />
            {mostrar2025 && (
              <>
                <col />
                <col />
                <col />
                <col />
                <col />
              </>
            )}
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th rowSpan="3" style={{ width: "110px", minWidth: "110px", maxWidth: "110px" }}>
                MES
              </th>
              <th colSpan={mostrar2025 ? "12" : "7"} style={{ backgroundColor: "#0b4b1aff" }}>
                CIERRES
              </th>
            </tr>
            <tr>
              {mostrar2025 && (
                <th colSpan="5" style={{ backgroundColor: "#107027ff" }}>
                  2025
                </th>
              )}
              <th colSpan="7" style={{ backgroundColor: "#107027ff" }}>
                2026
              </th>
            </tr>
            <tr>
              {mostrar2025 && (
                <>
                  <th className={styles.headerCierres}>Publicidad</th>
                  <th className={styles.headerCierres}>Hardware</th>
                  <th className={styles.headerCierres}>Cartelería</th>
                  <th className={styles.headerCierres}>BTL</th>
                  <th className={styles.headerCierres}>Total</th>
                </>
              )}
              <th className={styles.headerCierres}>Publicidad</th>
              <th className={styles.headerCierres}>Hardware</th>
              <th className={styles.headerCierres}>Cartelería</th>
              <th className={styles.headerCierres}>BTL</th>
              <th className={styles.headerCierres}>Total</th>
              <th className={styles.headerCierres}>vs AA</th>
              <th className={styles.headerCierres}>
                Pipeline{" "}
                <span
                  onMouseEnter={showTip}
                  onMouseLeave={hideTip}
                  style={{
                    cursor: "help",
                    fontSize: "11px",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    borderRadius: "50%",
                    padding: "1px 5px",
                  }}
                >
                  ?
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {[...Array(12)].map((_, i) => {
              const d2025 = getDesglose(2025, i + 1, i + 1, "cierres");
              const d2026 = getDesglose(2026, i + 1, i + 1, "cierres");
              const pipeline = calcularPipelineBruto(i);
              return (
                <tr key={i}>
                  <th className={styles.monthCell}>{getMonthName(i)}</th>
                  {mostrar2025 && (
                    <>
                      <SubtotalCell
                        valor={d2025.publicidad}
                        monthIndex={i}
                        tipo="cierres"
                        year="2025"
                        vertical="publicidad"
                        {...subtotalProps}
                      />
                      <SubtotalCell
                        valor={d2025.hardware}
                        monthIndex={i}
                        tipo="cierres"
                        year="2025"
                        vertical="hardware"
                        {...subtotalProps}
                      />
                      <SubtotalCell
                        valor={d2025.carteleria}
                        monthIndex={i}
                        tipo="cierres"
                        year="2025"
                        vertical="carteleria"
                        {...subtotalProps}
                      />
                      <SubtotalCell
                        valor={d2025.btl}
                        monthIndex={i}
                        tipo="cierres"
                        year="2025"
                        vertical="btl"
                        {...subtotalProps}
                      />
                      <SubtotalCell
                        valor={d2025.total}
                        monthIndex={i}
                        tipo="cierres"
                        year="2025"
                        vertical={null}
                        {...subtotalProps}
                      />
                    </>
                  )}
                  <SubtotalCell
                    valor={d2026.publicidad}
                    monthIndex={i}
                    tipo="cierres"
                    year="2026"
                    vertical="publicidad"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2026.hardware}
                    monthIndex={i}
                    tipo="cierres"
                    year="2026"
                    vertical="hardware"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2026.carteleria}
                    monthIndex={i}
                    tipo="cierres"
                    year="2026"
                    vertical="carteleria"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2026.btl}
                    monthIndex={i}
                    tipo="cierres"
                    year="2026"
                    vertical="btl"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2026.total}
                    monthIndex={i}
                    tipo="cierres"
                    year="2026"
                    vertical={null}
                    {...subtotalProps}
                  />
                  <td className={styles.variacionCell}>
                    {shouldShowVsAA(2026, i, "cierres") ? (
                      <span style={{ color: d2026.total >= d2025.total ? "#28a745" : "#dc3545" }}>
                        {calcularVariacion(d2026.total, d2025.total)}
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td
                    className={styles.pipelineCell}
                    style={{ cursor: i >= currentMonthIndex ? "pointer" : undefined }}
                    onClick={i >= currentMonthIndex ? () => onOpenPipelineModal(i) : undefined}
                    title={i >= currentMonthIndex ? "Ver detalle pipeline" : undefined}
                  >
                    {i < currentMonthIndex ? "-" : `${getMoneda()}${getDisplayValue(pipeline)}`}
                  </td>
                </tr>
              );
            })}
            {PERIODS.map((row) => {
              const { start, end } = getPeriodRange(row);
              const d2025 = getDesglose(2025, start, end, "cierres");
              const d2026 = getDesglose(2026, start, end, "cierres");
              const pipeline = row.type === "year" ? calcularPipelineBrutoTotal() : 0;
              return (
                <tr key={row.label} className={row.bold ? styles.boldRow : ""} style={PERIOD_BG[row.type]}>
                  <th className={styles.monthCell}>{row.label}</th>
                  {mostrar2025 && (
                    <>
                      <SubtotalCell
                        valor={d2025.publicidad}
                        monthIndex={null}
                        tipo="cierres"
                        periodo={row.label}
                        year="2025"
                        vertical="publicidad"
                        {...subtotalProps}
                      />
                      <SubtotalCell
                        valor={d2025.hardware}
                        monthIndex={null}
                        tipo="cierres"
                        periodo={row.label}
                        year="2025"
                        vertical="hardware"
                        {...subtotalProps}
                      />
                      <SubtotalCell
                        valor={d2025.carteleria}
                        monthIndex={null}
                        tipo="cierres"
                        periodo={row.label}
                        year="2025"
                        vertical="carteleria"
                        {...subtotalProps}
                      />
                      <SubtotalCell
                        valor={d2025.btl}
                        monthIndex={null}
                        tipo="cierres"
                        periodo={row.label}
                        year="2025"
                        vertical="btl"
                        {...subtotalProps}
                      />
                      <SubtotalCell
                        valor={d2025.total}
                        monthIndex={null}
                        tipo="cierres"
                        periodo={row.label}
                        year="2025"
                        vertical={null}
                        {...subtotalProps}
                      />
                    </>
                  )}
                  <SubtotalCell
                    valor={d2026.publicidad}
                    monthIndex={null}
                    tipo="cierres"
                    periodo={row.label}
                    year="2026"
                    vertical="publicidad"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2026.hardware}
                    monthIndex={null}
                    tipo="cierres"
                    periodo={row.label}
                    year="2026"
                    vertical="hardware"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2026.carteleria}
                    monthIndex={null}
                    tipo="cierres"
                    periodo={row.label}
                    year="2026"
                    vertical="carteleria"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2026.btl}
                    monthIndex={null}
                    tipo="cierres"
                    periodo={row.label}
                    year="2026"
                    vertical="btl"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2026.total}
                    monthIndex={null}
                    tipo="cierres"
                    periodo={row.label}
                    year="2026"
                    vertical={null}
                    {...subtotalProps}
                  />
                  <td className={styles.variacionCell}>
                    {shouldShowVsAA(2026, null, "cierres") ? (
                      <span style={{ color: d2026.total >= d2025.total ? (row.bold ? "#fff" : "#28a745") : "#dc3545" }}>
                        {calcularVariacion(d2026.total, d2025.total)}
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td
                    className={row.bold ? "text-end" : styles.pipelineCell}
                    style={{ cursor: row.type === "year" ? "pointer" : "default" }}
                    onClick={row.type === "year" ? () => onOpenPipelineModal(0, true) : undefined}
                    title={row.type === "year" ? "Ver detalle pipeline" : undefined}
                  >
                    {row.type === "year" ? (
                      <>
                        {getMoneda()}
                        {getDisplayValue(pipeline)}
                      </>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    );
  }

  // Vista Facturación
  return (
    <table className={styles.tableVentas}>
      <colgroup>
        <col />
        {mostrar2025 && (
          <>
            <col />
            <col />
            <col />
            <col />
            <col />
          </>
        )}
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th rowSpan="3" style={{ width: "110px", minWidth: "110px", maxWidth: "110px" }}>
            MES
          </th>
          <th colSpan={mostrar2025 ? "12" : "7"} style={{ backgroundColor: "#0c0c58ff" }}>
            FACTURACIÓN
          </th>
        </tr>
        <tr>
          {mostrar2025 && (
            <th colSpan="5" style={{ backgroundColor: "#1b1b8ddf" }}>
              2025
            </th>
          )}
          <th colSpan="7" style={{ backgroundColor: "#1b1b8ddf" }}>
            2026
          </th>
        </tr>
        <tr>
          {mostrar2025 && (
            <>
              <th className={styles.headerFacturacion}>Publicidad</th>
              <th className={styles.headerFacturacion}>Hardware</th>
              <th className={styles.headerFacturacion}>Cartelería</th>
              <th className={styles.headerFacturacion}>BTL</th>
              <th className={styles.headerFacturacion}>Total</th>
            </>
          )}
          <th className={styles.headerFacturacion}>Publicidad</th>
          <th className={styles.headerFacturacion}>Hardware</th>
          <th className={styles.headerFacturacion}>Cartelería</th>
          <th className={styles.headerFacturacion}>BTL</th>
          <th className={styles.headerFacturacion}>Total</th>
          <th className={styles.headerFacturacion}>vs AA</th>
          <th className={styles.headerFacturacion}>vs AAA</th>
        </tr>
      </thead>
      <tbody>
        {[...Array(12)].map((_, i) => {
          const d2025 = getDesglose(2025, i + 1, i + 1, "facturacion");
          const d2026 = getDesglose(2026, i + 1, i + 1, "facturacion");
          return (
            <tr key={i}>
              <th className={styles.monthCell}>{getMonthName(i)}</th>
              {mostrar2025 && (
                <>
                  <SubtotalCell
                    valor={d2025.publicidad}
                    monthIndex={i}
                    tipo="facturacion"
                    year="2025"
                    vertical="publicidad"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2025.hardware}
                    monthIndex={i}
                    tipo="facturacion"
                    year="2025"
                    vertical="hardware"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2025.carteleria}
                    monthIndex={i}
                    tipo="facturacion"
                    year="2025"
                    vertical="carteleria"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2025.btl}
                    monthIndex={i}
                    tipo="facturacion"
                    year="2025"
                    vertical="btl"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2025.total}
                    monthIndex={i}
                    tipo="facturacion"
                    year="2025"
                    vertical={null}
                    {...subtotalProps}
                  />
                </>
              )}
              <SubtotalCell
                valor={d2026.publicidad}
                monthIndex={i}
                tipo="facturacion"
                year="2026"
                vertical="publicidad"
                {...subtotalProps}
              />
              <SubtotalCell
                valor={d2026.hardware}
                monthIndex={i}
                tipo="facturacion"
                year="2026"
                vertical="hardware"
                {...subtotalProps}
              />
              <SubtotalCell
                valor={d2026.carteleria}
                monthIndex={i}
                tipo="facturacion"
                year="2026"
                vertical="carteleria"
                {...subtotalProps}
              />
              <SubtotalCell
                valor={d2026.btl}
                monthIndex={i}
                tipo="facturacion"
                year="2026"
                vertical="btl"
                {...subtotalProps}
              />
              <SubtotalCell
                valor={d2026.total}
                monthIndex={i}
                tipo="facturacion"
                year="2026"
                vertical={null}
                {...subtotalProps}
              />
              <td className={styles.variacionCell}>
                {shouldShowVsAA(2026, i, "facturacion") ? (
                  <span style={{ color: d2026.total >= d2025.total ? "#28a745" : "#dc3545" }}>
                    {calcularVariacion(d2026.total, d2025.total)}
                  </span>
                ) : (
                  "-"
                )}
              </td>
              <td className={styles.variacionCell}>
                {(() => {
                  const d2024 = getDesglose(2024, i + 1, i + 1, "facturacion");
                  if (!d2024.total || d2024.total === 0) return "-";
                  return (
                    <span style={{ color: d2026.total >= d2024.total ? "#28a745" : "#dc3545" }}>
                      {calcularVariacion(d2026.total, d2024.total)}
                    </span>
                  );
                })()}
              </td>
            </tr>
          );
        })}
        {PERIODS.map((row) => {
          const { start, end } = getPeriodRange(row);
          const d2025 = getDesglose(2025, start, end, "facturacion");
          const d2026 = getDesglose(2026, start, end, "facturacion");
          return (
            <tr key={row.label} className={row.bold ? styles.boldRow : ""} style={PERIOD_BG[row.type]}>
              <th className={styles.monthCell}>{row.label}</th>
              {mostrar2025 && (
                <>
                  <SubtotalCell
                    valor={d2025.publicidad}
                    monthIndex={null}
                    tipo="facturacion"
                    periodo={row.label}
                    year="2025"
                    vertical="publicidad"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2025.hardware}
                    monthIndex={null}
                    tipo="facturacion"
                    periodo={row.label}
                    year="2025"
                    vertical="hardware"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2025.carteleria}
                    monthIndex={null}
                    tipo="facturacion"
                    periodo={row.label}
                    year="2025"
                    vertical="carteleria"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2025.btl}
                    monthIndex={null}
                    tipo="facturacion"
                    periodo={row.label}
                    year="2025"
                    vertical="btl"
                    {...subtotalProps}
                  />
                  <SubtotalCell
                    valor={d2025.total}
                    monthIndex={null}
                    tipo="facturacion"
                    periodo={row.label}
                    year="2025"
                    vertical={null}
                    {...subtotalProps}
                  />
                </>
              )}
              <SubtotalCell
                valor={d2026.publicidad}
                monthIndex={null}
                tipo="facturacion"
                periodo={row.label}
                year="2026"
                vertical="publicidad"
                {...subtotalProps}
              />
              <SubtotalCell
                valor={d2026.hardware}
                monthIndex={null}
                tipo="facturacion"
                periodo={row.label}
                year="2026"
                vertical="hardware"
                {...subtotalProps}
              />
              <SubtotalCell
                valor={d2026.carteleria}
                monthIndex={null}
                tipo="facturacion"
                periodo={row.label}
                year="2026"
                vertical="carteleria"
                {...subtotalProps}
              />
              <SubtotalCell
                valor={d2026.btl}
                monthIndex={null}
                tipo="facturacion"
                periodo={row.label}
                year="2026"
                vertical="btl"
                {...subtotalProps}
              />
              <SubtotalCell
                valor={d2026.total}
                monthIndex={null}
                tipo="facturacion"
                periodo={row.label}
                year="2026"
                vertical={null}
                {...subtotalProps}
              />
              <td className={styles.variacionCell}>
                {shouldShowVsAA(2026, null, "facturacion") ? (
                  <span style={{ color: d2026.total >= d2025.total ? (row.bold ? "#fff" : "#28a745") : "#dc3545" }}>
                    {calcularVariacion(d2026.total, d2025.total)}
                  </span>
                ) : (
                  "-"
                )}
              </td>
              <td className={styles.variacionCell}>
                {(() => {
                  const d2024 = getDesglose(2024, start, end, "facturacion");
                  if (!d2024.total || d2024.total === 0) return "-";
                  return (
                    <span
                      style={{
                        color: d2026.total >= d2024.total ? (row.bold ? "#fff" : "#28a745") : "#dc3545",
                      }}
                    >
                      {calcularVariacion(d2026.total, d2024.total)}
                    </span>
                  );
                })()}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
